import { IDENTIFIER_TYPE } from 'src/features/membership/types';
import { allowListMessages } from 'src/features/allowList/utils/allowListMessages';

export enum ALLOW_LIST_TYPE {
    WHITE = 'white',
    BLACK = 'black',
}

export const ALLOW_LIST_TYPE_TRANSLATION_MAP = {
    [ALLOW_LIST_TYPE.WHITE]: allowListMessages.whiteList,
    [ALLOW_LIST_TYPE.BLACK]: allowListMessages.blackList,
}

export type AllowList = {
    id: string;
    created_at: string;
    modified_at: string;
    name: string;
    description: string | null;
    type: ALLOW_LIST_TYPE;
    allowed_gateways: string[];
    zones: string[];
};

export type AllowListItem = {
    id: string;
    created_at: string;
    modified_at: string;
    name: string;
    identifier_type: IDENTIFIER_TYPE;
    identifier_value: string;
}